import React from 'react';

import AggregatedProductAttributesView from '../AggregatedProductAttributesView';

const AggregatedDraftDetails = () => (
  <AggregatedProductAttributesView mode="draft" />
);

export default AggregatedDraftDetails;
